export default __webpack_public_path__ + "static/media/Briefcase_News_Acceptable_use_policy_10_March_2020.d3af8b18.pdf";